module.exports = __webpack_public_path__ + "img/gimp.048b94df.png";